import React from "react";
import Skeleton from "@mui/material/Skeleton";

/**
 *
 * @param {Boolean} condition If true, display children, otherwise display Skeleton
 * @param {String | Component} fallback Loading skeleton
 * @param {String | Component} children Content displayed once condition evaluates to true
 * @returns {Component} Skeleton | Component
 */
export default function LoadEffect({
  condition,
  fallback = <Skeleton variant="rounded" width="100%" height="25px" />,
  children,
}) {
  return condition ? children : fallback;
}
